import Vue from 'vue'
import Navbar from './App.vue'
import SitesDropdown from './components/SitesDropdown'
import Buefy from 'buefy'


Vue.use(Buefy, {
  defaultIconPack: 'fas',
})
Vue.use(SitesDropdown)


if(document.getElementById("dashNav")){
  new Vue({
    render: h => h(Navbar, {
      props: {
        companyName: document.getElementById("dashNav")
          .getAttribute("company-name"),
        companyId: document.getElementById("dashNav")
          .getAttribute("company-id"),
        userName: document.getElementById("dashNav")
          .getAttribute("user-name"),
        mainDomain: document.getElementById("dashNav")
          .getAttribute("main-domain"),
        currentSite: document.getElementById("dashNav")
          .getAttribute("current-site"),
        companiesEndpoint: document.getElementById("dashNav")
          .getAttribute("companies-endpoint")
      }
    }),
  }).$mount('#dashNav')
}
